// ─────────────────────────────────────────────────────────────────────────────
// Límites de forma del mensaje de un reconocimiento. Viven junto al contrato de la API porque los
// fija el backend (`Recognition.MensajeMaxLength` en RecognitionService), no la pantalla: cada
// superficie de escritura los consume desde aquí en vez de repetir el número.
//
// Antes cada pantalla llevaba el suyo —1500 en la edición posterior al envío, 500 en la nominación
// de campaña y NINGUNO en el formulario de Reconocer ni en el post-it interactivo—, así que el
// usuario podía escribir de más y solo se enteraba cuando el backend rechazaba el envío con el
// título genérico «Error de validación en los datos enviados».
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Máximo de caracteres del mensaje, homologado en TODOS los puntos donde se escribe un
 * reconocimiento: formulario clásico, post-it interactivo, nominación de campaña y edición
 * posterior al envío. Debe coincidir con `Recognition.MensajeMaxLength` del backend — si allá
 * cambia, este es el único lugar que hay que mover en el frontend.
 */
export const MENSAJE_MAX_LENGTH = 3000;

/**
 * A partir de cuántos caracteres restantes se avisa al usuario. El aviso es preventivo: aparece
 * mientras todavía puede escribir (a los 2900 con el tope en 3000), no cuando ya se topó.
 */
export const MENSAJE_WARN_REMAINING = 100;

/**
 * Caracteres que le quedan al usuario, nunca negativo. Un mensaje que ya excede el tope —posible
 * en un reconocimiento guardado antes de homologar el límite— devuelve 0, no un negativo que la
 * pantalla tendría que interpretar.
 */
export function mensajeRestantes(length: number, max: number = MENSAJE_MAX_LENGTH): number {
  return Math.max(0, max - length);
}

/** ¿Toca avisar? Solo dentro de la franja final (los últimos `MENSAJE_WARN_REMAINING` caracteres). */
export function debeAvisarLimite(length: number, max: number = MENSAJE_MAX_LENGTH): boolean {
  return length >= max - MENSAJE_WARN_REMAINING;
}
